// Entrypoint for the Unify Browser ESM/Dart bundle
import * as UnifyUI from 'src/browser';
export * from 'src/browser';

// All unify_ui code uses the UnifyUI namespace, but we still support ReactMaterialUI to maintain
// backwards compatibility with older versions of unify_ui. Once all consumers are on new enough
// versions of unify_ui, we can remove the ReactMaterialUI namespace.
globalThis.ReactMaterialUI = globalThis.UnifyUI = Object.assign({}, UnifyUI);
